import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Pagination from "react-js-pagination";

const CustomPagination = ({ resPerPage, filteredProductsCount, results }) => {
  const [currentPage, setCurrentPage] = useState();

  let [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const page = Number(searchParams.get("page")) || 1;

  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

  const setCurrentPageNo = (pageNumber) => {
    setCurrentPage(pageNumber);

    //     alert(pageNumber); // You can remove this line after testing

    if (searchParams.has("page")) {
      searchParams.set("page", pageNumber);
    } else {
      searchParams.append("page", pageNumber);
    }

    const path = window.location.pathname + "?" + searchParams.toString();
    // alert(path); // You can remove this line after testing
    navigate(path);
  };
  return (
    <nav className="pagy-nav pagination">
      {resPerPage && (
        <Pagination
          activePage={currentPage}
          itemsCountPerPage={resPerPage?.numberOfPages}
          totalItemsCount={filteredProductsCount}
          pageRangeDisplayed={5}
          onChange={setCurrentPageNo}
          itemClass="page-item"
          linkClass="page-link"
        />
      )}
    </nav>
  );
};

export default CustomPagination;
